import { GeneratorsTable } from "@/components/datatables/generators/Generators.table.tsx";
import { config } from "@/lib/config";
import { Button } from "@/components/base/Button";
import { Link } from "react-router-dom";
import { useStore } from "@/stores/useStore";
import { generator as generatorActions } from "@/repositories/generator";
import { LoadingPage } from "@/components/page/LoadingPage";

export const GeneratorsPage = () => {
  const tenantId = useStore((s) => s.tenant?.id);
  const handleGenerateGenerator = async () => {
    if (!tenantId) {
      return;
    }
    return generatorActions.generateRandom(tenantId);
  };

  if (!tenantId) {
    return <LoadingPage />;
  }
  return (
    <div className="p-4 w-full">
      <div className="flex flex-row space-between pb-4 gap-4">
        <h1 className="text-2xl font-bold ">Generators Table</h1>
        <div className="flex flex-grow" />
        {config.devMode && (
          <Button onClick={handleGenerateGenerator}>Generate Generator</Button>
        )}
        <Link to="create">
          <Button>Add Generator</Button>
        </Link>
      </div>
      <div className="flex flex-wrap gap-2 w-full">
        <GeneratorsTable />
      </div>
    </div>
  );
};
